export default __webpack_public_path__ + "media/images/icons/icon-arrow-slider-prev-dbf30f23fa8ce2eeb1b20b9534406366.svg";